import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Avatar,
  Badge,
  Button,
  Drawer,
  notification,
  Rate,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import CaregiverSchedule from "./CaregiverSchedule";
import { useEffect, useMemo, useState } from "react";
import { getAvatarPath } from "../../utils/userUtil";
import "./CaregiverRow.css";
import FavoriteCaregiverButton from "./FavoriteCaregiverButton";
import { faCircle, faPerson } from "@fortawesome/free-solid-svg-icons";
import { careTypeList } from "../../utils/careCategoryOptions";
import { caregiverAvailable } from "../../utils/caregiverAvailable";
import dayjs from "dayjs";
import { faStar } from "@fortawesome/pro-solid-svg-icons";

const CaregiverRow = ({ caregiver, favorites }) => {
  const [showSchedule, setShowSchedule] = useState(false);
  const [serviceType, setServiceType] = useState(caregiver?.CareType);
  const closeDrawer = () => {
    setShowSchedule(false);
  };

  useMemo(() => {
    Object.keys(careTypeList).forEach((c) => {
      let careType = careTypeList[c];
      if (careType.value === caregiver?.CareType)
        setServiceType(careType.label);
    });
  }, [caregiver]);

  const {
    FirstName,
    LastName,
    Avatar: UserAvatar,
    Bio,
    Rate: CaregiverRate,
    Categories,
    AgeGroups,
    TotalRatings,
    TotalStars,
  } = caregiver;

  let name = FirstName && LastName ? `${FirstName} ${LastName}` : FirstName;
  const available = caregiverAvailable(caregiver, dayjs().format);

  const calculateRating = () => {
    if (!TotalRatings || !TotalStars) return undefined;
    let rating = TotalStars / TotalRatings;
    return rating.toFixed(1);
  };

  let rating = calculateRating();

  return (
    <>
      <div className="caregiver-result">
        <div className="caregiver-flex">
          <div className="caregiver-avatar">
            <Avatar
              src={getAvatarPath(caregiver)}
              shape="square"
              size={100}
              icon={name.substring(0, 1)}
            />
            {rating && (
              <div style={{ textAlign: "center", marginTop: 5 }}>
                <FontAwesomeIcon icon={faStar} /> {rating}
              </div>
            )}
          </div>
          <div className="caregiver-meta">
            <Typography.Title level={4}>{name}</Typography.Title>
            <Typography.Title level={5} style={{ marginTop: 0 }}>
              {serviceType}
            </Typography.Title>

            <Typography.Paragraph type="secondary">
              <FontAwesomeIcon icon={faPerson} /> {AgeGroups?.join(", ")}
            </Typography.Paragraph>
          </div>
          <div className="caregiver-actions">
            <Space direction="vertical">
              <Space>
                <FavoriteCaregiverButton
                  favorites={favorites}
                  caregiver={caregiver}
                />
                <Button
                  type="primary"
                  onClick={() => setShowSchedule(true)}
                  size="large"
                >
                  <Space>
                    <FontAwesomeIcon icon={faCalendar} />
                    Schedule
                  </Space>
                </Button>
              </Space>
              <RateDisplay rate={CaregiverRate} />
            </Space>
          </div>
        </div>
        <Typography.Paragraph>
          {Categories.map((c) => (
            <Tag key={c}>{c}</Tag>
          ))}
        </Typography.Paragraph>
        <Typography.Paragraph
          ellipsis={{ ellipsis: true, rows: 2, expandable: true }}
        >
          {Bio}
        </Typography.Paragraph>
      </div>

      {showSchedule && (
        <Drawer
          maskClosable={false}
          open={showSchedule}
          destroyOnClose
          onClose={closeDrawer}
          closable
          title={`Schedule with ${caregiver?.FirstName}`}
        >
          <CaregiverSchedule caregiver={caregiver} onClose={closeDrawer} />
        </Drawer>
      )}
    </>
  );
};

const RateDisplay = ({ rate }) => {
  let r = rate / 2;
  return (
    <Tooltip title={`$${rate} per hour`}>
      <Typography.Text type="secondary">from</Typography.Text>{" "}
      <Typography.Text strong>${r}</Typography.Text>{" "}
      <Typography.Text type="secondary">per session</Typography.Text>
    </Tooltip>
  );
};

export default CaregiverRow;
